import React, { useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateComponent = () => {
  // const adminLogin = useSelector((state) => {
  //   return state.ERPAdminReducer.isAdminLogin;
  // });
  // const location = useLocation();

  const { isAdminLogin, adminDetail } = useSelector((state) => {
    return state.ERPAdminReducer;
  });
  const domainRef = useRef(adminDetail?.domain || null);
  return isAdminLogin ? (
    <Outlet />
  ) : (
    <Navigate to={`/${domainRef.current || ""}`} />
  );
};

export default PrivateComponent;
